module.exports = __webpack_public_path__ + "assets/71d4943c1b5d6d542435f48f1dd59ee5.png";